<div class="tooltip" *ngIf="params.value">
	<div [innerHTML]="params.value | noSanitize"></div>
</div>
